import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { DateRange } from 'owa-datetime-utils';
import { EventsCacheLockId } from 'owa-events-cache';
import { getCalendarEventsForDateRange } from './getCalendarEventsForDateRange';
import { getCalendarEventWithKeyFromLock } from '../../selectors/calendarFolderEventsSelectors';
import { LockedCalendarEventsReader } from '../../types/LockedCalendarEventsStore';

export function getLockedCalendarEventsReader(
    existingLockId: EventsCacheLockId
): LockedCalendarEventsReader {
    return {
        getCalendarEventsForDateRange: (
            folderId: string,
            dateRange: DateRange
        ): CalendarEvent[] => {
            return getCalendarEventsForDateRange(existingLockId, folderId, dateRange);
        },

        getFullCalendarEvent: (folderId: string | null, eventKey: string): CalendarEvent | null => {
            return getCalendarEventWithKeyFromLock(folderId, eventKey, existingLockId);
        },
    };
}
